import React, { forwardRef } from 'react';

const AttributesAsColsIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      {...otherProps}
    >
      <g clipPath="url(#clip0_337_5708)">
        <path
          d="M2.25 8.75H1C0.447715 8.75 0 9.19772 0 9.75V11C0 11.5523 0.447715 12 1 12H2.25C2.80228 12 3.25 11.5523 3.25 11V9.75C3.25 9.19772 2.80228 8.75 2.25 8.75Z"
          fill={color}
        />
        <path
          d="M11.559 8.921C11.394 8.80926 11.1993 8.74968 11 8.75H9.75C9.48478 8.75 9.23043 8.85536 9.04289 9.04289C8.85536 9.23043 8.75 9.48478 8.75 9.75V11C8.75 11.2652 8.85536 11.5196 9.04289 11.7071C9.23043 11.8946 9.48478 12 9.75 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V9.75C12 9.58628 11.9597 9.42506 11.8829 9.28052C11.806 9.13598 11.6948 9.01252 11.559 8.921Z"
          fill={color}
        />
        <path
          d="M2.25 4.375H1C0.447715 4.375 0 4.82272 0 5.375V6.625C0 7.17728 0.447715 7.625 1 7.625H2.25C2.80228 7.625 3.25 7.17728 3.25 6.625V5.375C3.25 4.82272 2.80228 4.375 2.25 4.375Z"
          fill={color}
        />
        <path
          d="M11.559 4.546C11.394 4.43426 11.1993 4.37468 11 4.375H9.75C9.48478 4.375 9.23043 4.48036 9.04289 4.66789C8.85536 4.85543 8.75 5.10978 8.75 5.375V6.625C8.75 6.89022 8.85536 7.14457 9.04289 7.33211C9.23043 7.51964 9.48478 7.625 9.75 7.625H11C11.2652 7.625 11.5196 7.51964 11.7071 7.33211C11.8946 7.14457 12 6.89022 12 6.625V5.375C12 5.21128 11.9597 5.05006 11.8829 4.90552C11.806 4.76098 11.6948 4.63752 11.559 4.546Z"
          fill={color}
        />
        <path
          d="M2.25 0H1C0.447715 0 0 0.447715 0 1V2.25C0 2.80228 0.447715 3.25 1 3.25H2.25C2.80228 3.25 3.25 2.80228 3.25 2.25V1C3.25 0.447715 2.80228 0 2.25 0Z"
          fill={color}
        />
        <path
          d="M7.184 8.921C7.01902 8.80926 6.82426 8.74968 6.625 8.75H5.375C5.10978 8.75 4.85543 8.85536 4.66789 9.04289C4.48036 9.23043 4.375 9.48478 4.375 9.75V11C4.375 11.2652 4.48036 11.5196 4.66789 11.7071C4.85543 11.8946 5.10978 12 5.375 12H6.625C6.89022 12 7.14457 11.8946 7.33211 11.7071C7.51964 11.5196 7.625 11.2652 7.625 11V9.75C7.62497 9.58628 7.58475 9.42506 7.50785 9.28052C7.43096 9.13598 7.31975 9.01252 7.184 8.921Z"
          fill={color}
        />
        <path
          d="M7.184 4.546C7.01902 4.43426 6.82426 4.37468 6.625 4.375H5.375C5.10978 4.375 4.85543 4.48036 4.66789 4.66789C4.48036 4.85543 4.375 5.10978 4.375 5.375V6.625C4.375 6.89022 4.48036 7.14457 4.66789 7.33211C4.85543 7.51964 5.10978 7.625 5.375 7.625H6.625C6.89022 7.625 7.14457 7.51964 7.33211 7.33211C7.51964 7.14457 7.625 6.89022 7.625 6.625V5.375C7.62497 5.21128 7.58475 5.05006 7.50785 4.90552C7.43096 4.76098 7.31975 4.63752 7.184 4.546Z"
          fill={color}
        />
        <path
          d="M7.184 0.171001C7.01902 0.05926 6.82426 -0.000316899 6.625 1.26774e-06H5.375C5.10978 1.26774e-06 4.85543 0.105358 4.66789 0.292895C4.48036 0.480431 4.375 0.734785 4.375 1V2.25C4.375 2.51522 4.48036 2.76957 4.66789 2.95711C4.85543 3.14464 5.10978 3.25 5.375 3.25H6.625C6.89022 3.25 7.14457 3.14464 7.33211 2.95711C7.51964 2.76957 7.625 2.51522 7.625 2.25V1C7.62497 0.836278 7.58475 0.675065 7.50785 0.530521C7.43096 0.385977 7.31975 0.262523 7.184 0.171001Z"
          fill={color}
        />
        <path
          d="M11.829 0.441C11.7375 0.305246 11.614 0.194039 11.4695 0.117146C11.3249 0.0402538 11.1637 2.74506e-05 11 0L9.75 0C9.48478 0 9.23043 0.105357 9.04289 0.292893C8.85536 0.48043 8.75 0.734784 8.75 1V2.25C8.75 2.51522 8.85536 2.76957 9.04289 2.95711C9.23043 3.14464 9.48478 3.25 9.75 3.25H11C11.2652 3.25 11.5196 3.14464 11.7071 2.95711C11.8946 2.76957 12 2.51522 12 2.25V1C12.0003 0.800739 11.9407 0.605982 11.829 0.441Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_337_5708">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

AttributesAsColsIcon.defaultProps = {
  style: {
    color: 'black',
  },
};

export default AttributesAsColsIcon;
